
import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import { ResearchType } from '../types/research-types';

interface ResearchTypeItemProps {
  type: ResearchType;
  isSelected: boolean;
  isExpanded: boolean;
  onSelect: (typeId: string) => void;
}

const ResearchTypeItem: React.FC<ResearchTypeItemProps> = ({
  type,
  isSelected,
  isExpanded,
  onSelect
}) => {
  const Icon = type.icon;

  return (
    <motion.div
      className={`
        relative overflow-hidden rounded-lg border-2 transition-all duration-200 cursor-pointer shadow-sm
        ${isSelected 
          ? `${type.border} ${type.lightBg} ${type.darkBorder} ${type.darkBg}` 
          : 'border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800 hover:border-gray-300 dark:hover:border-gray-600 hover:shadow-md'
        }
      `}
      onClick={() => onSelect(type.id)}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      <div className="flex items-center justify-between p-3">
        <div className="flex items-center space-x-3">
          <div className={`${type.color} rounded-lg p-2 text-white flex-shrink-0`}>
            <Icon size={16} />
          </div>
          <div>
            <h4 className="font-medium text-sm text-gray-900 dark:text-gray-100">
              {type.name}
            </h4>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              {type.description}
            </p>
          </div>
        </div>
        <motion.div
          animate={{ rotate: isExpanded ? 90 : 0 }}
          transition={{ duration: 0.2 }}
        >
          <ChevronRight 
            size={16} 
            className={`${type.chevronColor} dark:${type.chevronColor}`}
          />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ResearchTypeItem;
